<template>
  <div>
    <b-modal v-model="forcedPasswordChangeVisible" @close="$emit('close-resetpsw-modal')" :width="400" scroll="keep" animation="zoom-out">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Update Your Password</p>
          <button @click="$emit('close-resetpsw-modal')" type="button" class="delete"></button>
        </header>

        <div class="modal-card-body">


          <div class="content pt-2">
            <p>You have logged in with your temporary password. You must update your password in order to continue.</p>
          </div>

          <section>

            <b-field

                :type="invalidFields.newPassword == '' ? '' : 'is-danger'"
                :message="invalidFields.newPassword">
              <template slot="label">
                <div class="password-change-form-label">New Password <span class="has-text-danger">*</span></div>
              </template>
              <b-input @input="resetInvalidStatus('invalidNewPassword')" v-model="updatePasswordForm.newPassword" type="password" autocomplete="off" onclick="this.removeAttribute('readOnly')" password-reveal expanded></b-input>
            </b-field>

            <b-field

                :type="invalidFields.confirmPassword == '' ? '' : 'is-danger'"
                :message="invalidFields.confirmPassword">
              <template slot="label">
                <div class="password-change-form-label" id="confm_psw">Confirm Password <span class="has-text-danger">*</span></div>
              </template>
              <b-input @input="resetInvalidStatus('confirmPassword')" v-model="updatePasswordForm.confirmPassword" type="password" autocomplete="off" onclick="this.removeAttribute('readOnly')" password-reveal expanded></b-input>
            </b-field>

          </section>

        </div>

        <footer class="modal-card-foot">
          <div class="is-full column py-0 px-0">
            <div class="column">
              <div class="columns">
                <div class="column"></div>
                <div class="buttons">
                  <b-button @click="validateAndUpdatePassword" :loading="updatePasswordIsSubmitting"  type="is-success is-small">Update Now</b-button>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name:'update-password-modal',

  data(){
    return{
      forcedPasswordChangeVisible:true,
      loginFormIsSubmitting: false,
      updatePasswordIsSubmitting: false,

      invalidFields:{
        newPassword:'',
        confirmPassword:''
      },

      updatePasswordForm: {
        newPassword: "",
        confirmPassword: "",
      },

      formData: {
        username: "",
        password: "",
      },

      otpcode:'',
    }
  },

  methods:{

    resetInvalidStatus: function(key){
      this[key] = ''
      this.formIsInvalid = false
    },

    validateUpdatePasswordForm: function(){
      var formIsValid = true

      if(this.updatePasswordForm.newPassword.indexOf(' ') >= 0){
        this.invalidFields.newPassword = 'This field cannot left blank'
        formIsValid = false
      }else if(this.updatePasswordForm.newPassword==''){
        this.invalidFields.newPassword = 'Enter a new password'
        formIsValid = false
      }
      else if(this.updatePasswordForm.newPassword.length < 8){
        this.invalidFields.newPassword = 'Password must contain at least 8 characters'
        formIsValid = false
      }
      else{
        if(this.updatePasswordForm.confirmPassword.indexOf(' ') >= 0){
          this.invalidFields.confirmPassword = 'This field cannot left blank'
          formIsValid = false
        }
        else if(this.updatePasswordForm.confirmPassword==''){
          this.invalidFields.confirmPassword = 'Re-enter your new password'
          formIsValid = false
        }
        else{
          if(this.updatePasswordForm.confirmPassword!=this.updatePasswordForm.newPassword){
            this.invalidFields.confirmPassword = 'Password validation failed'
            formIsValid = false
          }
        }
      }

      if(formIsValid){
        return true
      }
      else{
        return false
      }
    },

    validateAndUpdatePassword: function(){
      if(this.validateUpdatePasswordForm()){
        this.submitUpdatePassword()
      }
    },

    submitUpdatePassword: function(){

      var component = this
      component.updatePasswordIsSubmitting = true

      axios.post(component.$base_url+'/agent/updatepassword', {
        auth_token:component.$root.agentAuthToken,
        user_id:component.$root.user_id,
        new_password:component.updatePasswordForm.newPassword

      })
          .then(function (response) {

            component.updatePasswordIsSubmitting = false

            if(response.data.success == true){
              console.log(response.data)
              component.$buefy.toast.open({
                message: response.data.message,
                type: 'is-success'
              })

              component.otpcode = response.data.otpcode
              component.$emit('update-psw-success',component.otpcode)

            }else{
              component.$buefy.toast.open({
                message: response.data.message,
                type: 'is-danger'
              })
              component.formIsSubmitting = false
            }

          })
          .catch(function (error) {
            console.log(error)
          });

    },

  }
}
</script>
